export default __webpack_public_path__ + "static/media/NoRacesMascot.b1a60f4c.png";